export const translations = {
	Connect: {
		no: 'Koble til',
	},
	Connected: {
		no: 'Tilkoblet',
	},
	'Not connected': {
		no: 'Ikke tilkoblet',
	},
	'Connecting...': {
		no: 'Kobler til...',
	},
	'Could not connect': {
		no: 'Klarte ikke Ã¥ koble til',
	},
};
